import { getTheme } from "@clipboard-health/ui-theme";
import { ThemeProvider } from "@emotion/react";
import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";
import { PageWrapper } from "@src/appV2/redesign/components/PageWrapper";
import { StickyScrollPageHeader } from "@src/appV2/redesign/components/StickyScrollPageHeader";
import { useRef } from "react";

import { TaxInformationPageContentContainer } from "./components/TaxInformationPageContentContainer";

export function TaxInformationPage() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const form1099UiConfig = useCbhFlag(CbhFeatureFlag.FORM_1099_UI, {
    defaultValue: { enabled: false },
  });

  if (!form1099UiConfig.enabled) {
    return null;
  }

  return (
    <ThemeProvider theme={getTheme()}>
      <PageWrapper variant="tertiary">
        <StickyScrollPageHeader
          title="Tax Information"
          scrollContainerRef={scrollRef}
          headerVariant="tertiary"
        />
        <TaxInformationPageContentContainer
          taxationYear={form1099UiConfig.taxationYear}
          formIssuanceThresholdInDollars={form1099UiConfig.formIssuanceThresholdInDollars}
          scrollRef={scrollRef}
        />
      </PageWrapper>
    </ThemeProvider>
  );
}
